module.exports = __webpack_public_path__ + "img/tiny.be5030ca.webp";